export default __webpack_public_path__ + "static/high-complexity-c29d21f6b8b221bf3c96e6ac7ce999ac.png";